import React from 'react';
import { createReactRenderer } from 'helpers/react-renderer';
import AgeVerification from './AgeVerification';
import AgeVerificationManual from './AgeVerification/Manual';
import AgeVerificationConfirm from './AgeVerification/Confirm';
import AgeVerificationError from './AgeVerification/Error';
import AgeVerificationPinOverride from './AgeVerification/PinOverride';

export const modalSteps = {
  AGE_VERIFICATION: 'AgeVerification',
  AGE_VERIFICATION_MANUAL: 'AgeVerificationManual',
  AGE_VERIFICATION_PIN_OVERRIDE: 'AgeVerificationPinOverride',
  AGE_VERIFICATION_CONFIRM: 'AgeVerificationConfirm',
  AGE_VERIFICATION_ERROR: 'AgeVerificationError',
};

const Components = {
  [modalSteps.AGE_VERIFICATION]: AgeVerification,
  [modalSteps.AGE_VERIFICATION_PIN_OVERRIDE]: AgeVerificationPinOverride,
  [modalSteps.AGE_VERIFICATION_MANUAL]: AgeVerificationManual,
  [modalSteps.AGE_VERIFICATION_CONFIRM]: AgeVerificationConfirm,
  [modalSteps.AGE_VERIFICATION_ERROR]: AgeVerificationError,
};

let RenderedComponent;

const RegisterRulesModal = ({
  deferred,
  defaultStep = modalSteps.AGE_VERIFICATION,
  defaultStepData = {},
}) => {
  const [step, setStep] = React.useState(defaultStep);
  const [stepData, setStepData] = React.useState(defaultStepData);

  const setStepWithoutData = nextStep => {
    setStep(nextStep);
    setStepData({});
  };

  const setStepWithData = ({ step: nextStep, data }) => {
    setStep(nextStep);
    setStepData(data);
  };

  const close = () => {
    // Wait until the close animation is completed before unmounting
    setTimeout(() => {
      RenderedComponent.unmount();
    }, 250);
  };

  const reject = () => {
    if (deferred) {
      deferred.reject();
    }
    close();
  };

  const resolve = () => {
    if (deferred) {
      deferred.resolve();
    }
    close();
  };

  const modalProps = {
    setStep: setStepWithoutData,
    setStepWithData,
    stepData,
    close,
    reject,
    resolve,
    defaultStepData,
  };

  const Component = Components[step];

  return <Component {...modalProps} />;
};

const initRegisterRulesModal = ({ deferred, step, stepData }) => {
  RenderedComponent = createReactRenderer({
    component: RegisterRulesModal,
    props: {
      deferred,
      defaultStep: step,
      defaultStepData: stepData,
    },
    selector: '[data-react-root="ReactModal"]',
  });

  RenderedComponent.mount();
};

window.initRegisterRulesModal = initRegisterRulesModal;
